export const API_REQ_TIMEOUT = 90 * 1000 // ms